export const QUESTIONS_W = [
// W01 解剖
{
  q: '①腎臓は【後腹膜】臓器であり，大きさは約【12】～【13】cm，重さは【120】～【130】g，高さは脊椎の【Th12】～【L3】レベルにある．対側に比べ【右】腎は2～3cm低位に存在する．',
  s: 'W01', ch: '解剖',
},
{
  q: '②尿管の長さは25～30cmで，生理的狭窄部位は【3】箇所ある(【腎盂尿管】移行部，【総腸骨動脈】交叉部，【膀胱尿管】移行部)．尿管は総腸骨動静脈の【前】を通過し，逆流防止のため膀胱壁を【斜め】に貫き，【膀胱三角】部に開口する．',
  s: 'W01', ch: '解剖',
},
{
  q: '③膀胱の容量は【3】00～【5】00mL程度で，正常では残尿量が【50】mL以下である．膀胱の筋層は【3】層構造の平滑筋で構成される．膀胱上面は【腹膜】で覆われている．膀胱頂部と臍帯の間にある構造を【尿膜管】という．',
  s: 'W01', ch: '解剖',
},
{
  q: '④腎盂，尿管，膀胱を覆う上皮は組織学的に【移行】上皮と呼ばれる．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑤腎門部では前から【静脈】，【動脈】，【尿管】の順に脈管が存在する．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑥腎動脈は【右】の方が長く，腎静脈は【左】の方が長く太い．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑦精巣/卵巣静脈と副腎静脈は，左は【左腎】静脈に，右は【下大】静脈に流入する．精巣/卵巣動脈は【大】動脈から直接分岐し，膀胱動脈・子宮動脈・下直腸動脈は【内腸骨】動脈から分岐する．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑧前立腺の大きさは【くるみ】大で20mLほどであり，【アンドロゲン】作用によって維持されている．前立腺は【直腸】指診で触れることができ，正常の触診所見は【弾】性軟～硬．【移行】領域(内腺)，【中心】領域，【辺縁】領域(外腺)にわかれ，前立腺肥大症は【移行】領域，前立腺癌は【辺縁】領域に好発する．この2疾患のうち尿閉をきたしやすいのは【前立腺肥大症】である．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑨精巣は精巣【白膜】で覆われており，内部に精巣【中隔】を有する．間質には【LH】刺激を受ける【Leydig】細胞が存在し，【テストステロン】分泌を行っている．精細管には【FSH】刺激と【テストステロン】刺激を受ける【Sertoli】細胞が存在し，精子の分化(造精機能促進)に関与する．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑩精子は精祖細胞→一次精母細胞→二次精母細胞→精子細胞と分化することで形成される．減数分裂を行うのは一次【精母】細胞である．精子は【精細管】で分化し，【精巣上体】で成熟する．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑪アンドロゲンはテストステロン，ジヒドロテストステロン(DHT)，デヒドロエピアンドロステロン(DHEA)などの総称であり，テストステロンは【5α還元酵素】により作用の強い【ジヒドロテストステロン】に変換される．前立腺肥大症と男性型脱毛症の治療薬に【5α還元酵素阻害】薬がある．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑫精液は精子以外に【精囊】，【前立腺】，【カウパー腺】からの分泌液も含んでおり，このうち主成分となるのは【精囊】からの分泌液である．精液は精管から【射精管】を経て，【前立腺】部尿道に開口する．尿道は陰茎の【腹】側を通る．精液には子宮【収縮】作用がある．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑬精索とは精管，精巣動静脈，神経を含む索状物で，【鼠径】管を通過する．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑭蓄尿は【交感】神経系優位，排尿は【副交感】神経系優位に働く．',
  s: 'W01', ch: '解剖',
  type: 'grouped',
  categories: [
    {
      label: '排尿筋',
      groups: [{ label: '', rows: [
        { term: '蓄尿', desc: '下腹神経 → 【β】受容体' },
        { term: '排尿', desc: '【骨盤】神経 → 【ムスカリン受容体】' },
      ]}]
    },
    {
      label: '内尿道括約筋',
      groups: [{ label: '', rows: [
        { term: '蓄尿', desc: '下腹神経 → 【α】受容体' },
        { term: '排尿', desc: '【骨盤】神経 → 【cGMP】が関与' },
      ]}]
    },
    {
      label: '外尿道括約筋',
      groups: [{ label: '', rows: [
        { term: '蓄尿', desc: '【陰部】神経 → ニコチン受容体' },
      ]}]
    },
  ]
},
{
  q: '過活動膀胱の治療薬は【β3】刺激薬，【抗コリン】薬．前立腺肥大症の治療薬は【α1】遮断薬，PDE5阻害薬など．前立腺全摘後や経尿道的前立腺切除術(TURP)後に【尿失禁】をきたす．外尿道括約筋は【横紋】筋．',
  s: 'W01', ch: '解剖',
},
{
  q: '⑮勃起は【副交感】神経の興奮で生じ，中枢は【仙】髄にある．射精は【交感】神経の興奮で生じ，中枢は【胸腰】髄にある．',
  s: 'W01', ch: '解剖',
},

// W01 尿路の造影検査
{
  q: '①静脈内に造影剤を投与し，腎臓から尿路に排泄されたところを撮影するものを【排泄性】(【静脈性】)【尿路造影】(IVU)という．尿路は生理的な蠕動運動により，正常でも造影されない部分がある．施行不可となるのは【腎機能】低下例や【造影剤アレルギー】患者である．',
  s: 'W01', ch: '尿路の造影検査',
},
{
  q: '②膀胱鏡を使いながら尿管までカテーテルを挿入し，造影剤を注入して撮影するものを【逆行性尿路造影】(RP)という．血管内に造影剤が入らず，腎機能低下や造影剤アレルギーがあっても施行可能．施行不可となるのは【尿路感染】症がある場合である．',
  s: 'W01', ch: '尿路の造影検査',
},
{
  q: '③膀胱までカテーテルを挿入し，造影剤を注入して撮影するものを【逆行性膀胱造影】という．',
  s: 'W01', ch: '尿路の造影検査',
},
{
  q: '④外尿道口から尿道に造影剤を直接注入して撮影するものを【逆行性尿道造影】という．尿道【損傷】，尿道【狭窄】(【前立腺肥大】症)の診断に有用．',
  s: 'W01', ch: '尿路の造影検査',
},
{
  q: '⑤IVUや逆行性膀胱造影の手技で膀胱内に造影剤を貯留させ，その後排尿させながら撮影するものを【排尿時尿道造影】(VCUG)という．【膀胱尿管逆流】(【VUR】)の診断に有用．',
  s: 'W01', ch: '尿路の造影検査',
},
// W02 下部尿路症状
{
  q: '①蓄尿症状には尿【失禁】，夜間【頻尿】，尿意【切迫】感などがある．',
  s: 'W02', ch: '下部尿路症状',
},
{
  q: '②排尿症状には【尿勢】低下，排尿【遅延】，【腹圧】排尿などがある．',
  s: 'W02', ch: '下部尿路症状',
},
{
  q: '③排尿後症状には【残尿】感，排尿後尿【滴下】などがある．',
  s: 'W02', ch: '下部尿路症状',
},
{
  q: '④神経系が原因となり，膀胱の機能に障害をきたした状態を【神経因性膀胱】という．',
  s: 'W02', ch: '下部尿路症状',
},

// W02 蓄尿障害
{
  q: '②切迫性尿失禁は運動性と知覚性に分けられる．運動性は【大脳】の障害で橋への排尿抑制が出来なくなることで生じ，原因疾患に【Parkinson】病，【脳血管】障害などがある．知覚性は抑制が効かないほどの強い尿意が原因で，原因疾患に【過活動膀胱】や【膀胱炎】がある．いずれも尿意は【ある】．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '③反射性尿失禁は【脊髄】の障害で生じ，尿意は【ない】．二分脊椎や脊髄小脳変性症などが原因となる．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '④腹圧性尿失禁は【骨盤底筋群】の脆弱化で生じ，笑ったとき，くしゃみなどの際に失禁してしまう．尿意は【ない】．高齢，多産がリスクとなり女性に多い．治療は骨盤底筋群訓練，尿スリング手術．【切迫】性尿失禁と合併して【混合】性尿失禁をきたすことも多い．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '⑤溢流性(奇異性)尿失禁は，排尿困難で膀胱容量が限界を迎え尿失禁に至る．原因は【前立腺肥大】症や【抗コリン薬】服用，【糖尿病】性【末梢神経】障害など尿閉をきたしうるものである．基本的に尿意は【ある】が，糖尿病性末梢神経障害のような神経因性膀胱では尿意が【ない】．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '⑥機能性尿失禁は，排尿機能は正常だが【歩行】筋力の低下や【認知】症が原因で尿失禁に至ることである．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '⑦尿意切迫感・頻尿の診察では，まず【神経】疾患を除外し，次に【尿路感染症】を除外するために【尿】検査を行う．尿検査で血尿を認めた場合は，【膀胱癌】を疑う必要がある．尿検査が正常だった場合，次に【残尿】量を測定し，【50】mL以上であれば【溢流】性尿失禁と診断し原因検索にあたる．残尿量が正常であった場合には【過活動膀胱】と診断する．',
  s: 'W02', ch: '蓄尿障害',
},
{
  q: '⑧過活動膀胱',
  s: 'W02', ch: '蓄尿障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・症状：【尿意切迫感】，昼間頻尿，【夜間頻尿】，【切迫】性尿失禁など' },
    { level: 0, text: '・診断：【過活動膀胱症状スコア】(OABSS)で上記4つの症状をスコアリング．尿路感染症，【溢流性】尿失禁など他疾患を除外して診断する' },
    { level: 0, text: '・治療：【抗コリン】薬，【β3刺激】薬など(ただし前立腺肥大症を伴う場合，【抗コリン】薬は禁忌)' },
  ]
},

// W02 排尿障害
{
  q: '①排尿障害の原因に，糖尿病や脊髄損傷による【神経因性膀胱】，【前立腺肥大】症，薬物(【抗コリン】薬，抗ヒスタミン薬，抗うつ薬)などがある．検査としてまずは腹部【超音波】検査にて残尿量を測定する(正常では50mL以下)．尿流動態検査で尿勢【低下】，排尿時間の【延長】などを認める．',
  s: 'W02', ch: '排尿障害',
},
{
  q: '②神経因性膀胱の治療は【ChE阻害】薬などで，無効の場合は【間欠自己導尿】や【腹圧】排尿(ただし，腎盂や尿管に拡張がある場合は不可)を試みる．',
  s: 'W02', ch: '排尿障害',
},
{
  q: '③前立腺肥大症の尿流測定では尿流速度の【低下】，排尿時間【延長】，【鋸】状の尿流曲線(腹圧排尿)，排尿量【低下】がみられる．',
  s: 'W02', ch: '排尿障害',
},
{
  q: '④神経因性膀胱では尿路造影検査で，膀胱【肉柱形成】や【松笠】状膀胱がみられる．',
  s: 'W02', ch: '排尿障害',
},
{
  q: '⑤膀胱結石や膀胱腫瘍では尿線中絶，体動による排尿再開を認めることがある．膀胱憩室では【二段】排尿を認めることもある．',
  s: 'W02', ch: '排尿障害',
},

// W02 尿が出ないときの処置
{
  q: '①「尿が出ない」患者には，まず腹部【超音波】検査を行い無尿か尿閉かを鑑別する．次いで，【腎盂】を確認し【水腎】症の有無を確認する．',
  s: 'W02', ch: '尿が出ないときの処置',
},
{
  q: '②膀胱に尿が充満しているが排尿できない状態を【尿閉】という．原因に尿道結石，【前立腺肥大症】，前立腺癌，子宮脱，【神経因性膀胱】(糖尿病，脊髄損傷)などがある．尿閉の場合，処置としてまず【尿道カテーテル】を試みる．尿道損傷や高度前立腺肥大症で困難な場合は【膀胱瘻】を造設する．',
  s: 'W02', ch: '尿が出ないときの処置',
},
{
  q: '③尿が出ない患者で膀胱内に尿の貯留がなければ無尿である．原因に【尿管】結石や膀胱癌がある．処置としてまず【尿管ステント】を試み，それが困難な場合は【腎瘻】を造設する．',
  s: 'W02', ch: '尿が出ないときの処置',
},
{
  q: '④前立腺肥大症患者に【抗コリン】薬を投与すると尿閉をきたすことに注意する．',
  s: 'W02', ch: '尿が出ないときの処置',
},

// W02 尿道カテーテル
{
  q: '①尿道カテーテルの適応に【尿閉】の解除，【尿量】の測定(循環動態の確認)がある．',
  s: 'W02', ch: '尿道カテーテル',
},
{
  q: '②男性の尿道カテーテルの入れ方',
  s: 'W02', ch: '尿道カテーテル',
  type: 'indent',
  rows: [
    { level: 0, text: '・【清】潔操作にて挿入する' },
    { level: 0, text: '・陰茎を【上】方に牽引しながら挿入し，【尿の流出】を確認してからバルーンに【蒸留】水を入れて固定する' },
    { level: 0, text: '・陰茎を【上】向きにし，カテーテルを【下腹】部に固定する' },
    { level: 0, text: '・感染がなくとも【1ヵ月】ごとにカテーテルを交換する' },
    { level: 0, text: '・体動制限は【不】要' },
  ]
},
{
  q: '③尿道カテーテルの長期留置は【尿路感染症】や【膀胱結石】の原因となる．',
  s: 'W02', ch: '尿道カテーテル',
},
{
  q: '④金属等を挿入し尿管を拡張させる処置を【尿道ブジー】といい，高度【尿道狭窄】で尿道カテーテル挿入が困難な例や，【内視鏡】挿入の前処置として行われる．',
  s: 'W02', ch: '尿道カテーテル',
},
// W03 膀胱尿管逆流(VUR)
{
  q: '①膀胱尿管逆流(VUR)は【乳児】期の【男】児，【幼児】期以降の【女】児に多く，【両】側性が多い．最多の原因は【膀胱三角】部の筋層発育不全で，他に【重複腎盂尿管】，【異所尿管開口】，【神経因性膀胱】，後部尿道弁などが原因となる．',
  s: 'W03', ch: '膀胱尿管逆流(VUR)',
},
{
  q: '②膀胱尿管逆流(VUR)そのものの症状はないが，反復性【尿路感染症】や【腎】障害の原因となる．確定診断は【排尿時膀胱尿道】造影で尿管への逆流を認めることで得られる．腎瘢痕の程度を確認するために99mTc-DMSA腎シンチグラフィを行う．',
  s: 'W03', ch: '膀胱尿管逆流(VUR)',
},
{
  q: '③膀胱尿管逆流(VUR)は，小児では【自然軽快】が望めるため，予防的【抗菌薬】投与などの保存療法を中心とする．重症例の外科的治療としては【膀胱尿管新吻合】術や膨張剤の内視鏡的注入法がある．',
  s: 'W03', ch: '膀胱尿管逆流(VUR)',
},

// W03 停留精巣
{
  q: '①発生過程において，精巣が下降途中で停留し陰囊まで到達しない先天異常を【停留精巣】という．頻度は出生時に約3～5％，1歳時に約1%で，【低出生体重】児では出生時約20%と高率となる．【片】側性が多く，陰囊内に精巣を触れない．',
  s: 'W03', ch: '停留精巣',
},
{
  q: '②停留精巣を放置すると精巣の高温環境による【精子形成】障害(手術した場合も男性【不妊】症の可能性が残る)が起こる．さらに【精巣腫瘍】，【鼠径】ヘルニアや陰囊水腫，【精巣捻転】症のリスクにもなる．【1】歳までは経過観察するが，自然下降しない場合は【1】～【2】歳までに【精巣固定】術を行う．',
  s: 'W03', ch: '停留精巣',
},

// W03 その他の奇形
{
  q: '①1つの腎に腎盂・尿管が重複して存在する奇形を【重複腎盂尿管】という．【尿管異所開口】，【膀胱尿管逆流】(尿路感染のリスク)を合併しやすい．また尿管が狭まることで，【水腎症】や尿路【結石】を起こしやすい．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '②尿管が膀胱三角以外に開口する奇形を【尿管異所開口】という．しばしば通過障害がみられ，逆流， [尿路感染症[ ， [水腎症[ ，腎障害などを合併する．男性では尿管が【精囊】や【精管】に開口するため，精巣上体炎や精囊炎などをきたす．女性では膣や膣前庭，内尿道括約筋より遠位の尿管に開口するため持続的な【尿失禁】をきたす．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '③尿管が下大静脈の後方を通る奇形を【下大静脈後尿管】という．【右】側に多く，尿管狭窄による【水腎症】，【尿路結石】を起こしやすい．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '④左右の腎が下極で融合している先天奇形を【馬蹄腎】といい，遺伝性はない．尿管が血管と腎臓に挟まれ圧迫されることで，水腎症や尿路結石を生じる．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑤腎盂尿管移行部狭窄症では腎盂・腎杯の拡張がみられる．症状は【水腎症】による側腹部痛や嘔吐，血尿，尿路感染などだが，無症状のことも多い．エコー，CT，MRI，逆行性尿路造影，レノグラムなどで診断する．治療は軽症・無症状であれば経過観察，拡張が高度で有症状のものは狭窄部切除，【腎盂形成術】を検討する．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑥骨盤臓器脱の原因は【加齢】や【出産】による【骨盤底筋】群の支持力低下で，膀胱瘤，子宮脱，直腸瘤を呈する．膀胱瘤では排尿困難，残尿，二段排尿，腹圧性尿失禁などを，直腸瘤では排便困難などを呈する．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑦結腸と膀胱が瘻孔を形成したものを【結腸膀胱瘻】といい，【気】尿や【糞】尿が特徴的である．尿路感染をきたしやすい．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑧前立腺部尿道の弁状構造物がみられる奇形を【後部尿道弁】という．合併症として【膀胱尿管逆流】や，排尿筋過活動による【尿失禁】をきたすことがある．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑨外尿道口が正常位置より近位で陰茎腹側に開口する先天奇形を【尿道下裂】という．陰茎は【腹】側に屈曲し，過剰な包皮のたるみや亀頭の露出がみられる．尿路感染症や尿失禁，尿閉は伴わないが，【立位】での排尿困難や陰茎屈曲による性交困難がみられる．また，高頻度に【停留精巣】を合併する．',
  s: 'W03', ch: 'その他の奇形',
},
{
  q: '⑩亀頭が包皮に覆われ翻転・露出できない状態を【真性包茎】という．乳児は生理的に真性包茎で，通常では思春期までに亀頭が露出する．排尿困難，亀頭包皮炎，尿路感染症，性器感染症，嵌頓包茎，陰茎癌のリスクになる．',
  s: 'W03', ch: 'その他の奇形',
},
// W04 前立腺肥大症
{
  q: '①前立腺肥大症は【加齢】に伴う【移行】領域(【内】腺)の過形成により下部尿路症状をきたす疾患である．前立腺肥大症が前立腺癌に進行することは【ない】が，鑑別は必要なので【PSA】測定は必須である．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '②前立腺肥大症と前立腺癌の比較',
  s: 'W04', ch: '前立腺肥大症',
  type: 'grouped',
  categories: [
    {
      label: '腫瘍の性質',
      groups: [{ label: '', rows: [
        { term: '前立腺肥大症(BPH)', desc: '良性' },
        { term: '前立腺癌', desc: '悪性' },
      ]}]
    },
    {
      label: '下部尿路症状',
      groups: [{ label: '', rows: [
        { term: '前立腺肥大症(BPH)', desc: '出【やすい】' },
        { term: '前立腺癌', desc: '出【にくい】(進行してから出現)' },
      ]}]
    },
    {
      label: '直腸診所見',
      groups: [{ label: '', rows: [
        { term: '前立腺肥大症(BPH)', desc: '表面【平滑】，弾性硬〜弾性軟' },
        { term: '前立腺癌', desc: '表面【不整】，【石様】硬' },
      ]}]
    },
    {
      label: 'PSA値',
      groups: [{ label: '', rows: [
        { term: '前立腺肥大症(BPH)', desc: '【正常】(ときに上昇)' },
        { term: '前立腺癌', desc: '【上昇】' },
      ]}]
    },
    {
      label: '治療',
      groups: [{ label: '', rows: [
        { term: '前立腺肥大症(BPH)', desc: '薬物療法，【TURP】' },
        { term: '前立腺癌', desc: '前立腺全摘除術，ホルモン療法，放射線療法' },
      ]}]
    },
  ]
},
{
  q: '③前立腺肥大症の症状には肥大した前立腺が膀胱を刺激して生じる【頻尿】，【夜】間【頻尿】，尿意切迫感，【残尿】感や，下部尿路狭窄による【尿勢低下】，【尿線途絶】，排尿後滴下，【腹圧】排尿，【溢流】性尿失禁などがある．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '④前立腺肥大症ではまず問診で【国際前立腺症状スコア】(【IPSS】)を用い症状を評価する．直腸指診で小【鶏卵】大・【鶏卵】大，弾性軟～硬の前立腺を触れる．尿流測定で尿流測定低下，排尿時間延長，鋸状の尿流曲線(腹圧排尿)などを認める．超音波検査で腫大した前立腺(正常は【20】mL)，膀胱に【残尿】を認める(正常で50mL以下)．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '⑤前立腺肥大症の患者に禁忌となる薬剤として，【抗コリン薬】(【感冒薬】，【抗ヒスタミン薬】，COPDの治療薬など)がある．尿閉を起こす危険性がある．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '⑥治療薬に【α1受容体遮断】薬(第一選択，尿道閉塞を防ぐ)，【5α還元酵素阻害】薬(作用の強い男性ホルモンであるジヒドロテストステロン産生を抑制する)，【ホスホジエステラーゼ】(【PDE】)5阻害薬，抗【アンドロゲン】薬がある．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '⑦重症例では【経尿道的前立腺切除】術(【TURP】)を行う．術中合併症に被膜穿孔や灌流液による低Na血症が，術後合併症に【逆行性】射精や尿【失禁】，尿道狭窄がある．',
  s: 'W04', ch: '前立腺肥大症',
},
{
  q: '⑧尿に関する用語の定義',
  s: 'W04', ch: '前立腺肥大症',
  type: 'indent',
  rows: [
    { level: 0, text: '・頻尿(昼間頻尿)：1日8回以上　夜間頻尿：1日【1】回以上' },
    { level: 0, text: '・多尿：【40】mL/kg・日以上　乏尿：【400】mL/日以下　無尿：【100】mL/日以下' },
    { level: 0, text: '・夜間多尿：夜間尿量の割合が高齢者で0.33以上，若年者で0.2以上' },
    { level: 0, text: '・夜間【遺尿】：夜間に無意識に排尿をきたすこと' },
  ]
},
// W05 泌尿器の癌の導入
{
  q: '①腎細胞癌/膀胱癌/前立腺癌/精巣腫瘍の比較',
  s: 'W05', ch: '泌尿器の癌の導入',
  type: 'grouped',
  categories: [
    {
      label: '組織',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '【淡明細胞】癌' },
        { term: '膀胱癌', desc: '【移行上皮】癌' },
        { term: '前立腺癌', desc: '【腺】癌' },
        { term: '精巣腫瘍', desc: '【セミノーマ】など' },
      ]}]
    },
    {
      label: '主な危険因子',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: 'VHL遺伝子，透析' },
        { term: '膀胱癌', desc: '喫煙，【芳香族アミン】' },
        { term: '前立腺癌', desc: '加齢，家族歴' },
        { term: '精巣腫瘍', desc: '【停留精巣】' },
      ]}]
    },
    {
      label: '症状',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '血尿，腫瘤，腰痛，高Ca血症' },
        { term: '膀胱癌', desc: '【無症候性血尿】，進行すると頻尿など' },
        { term: '前立腺癌', desc: '初期は尿路症状(−)，骨転移(【造骨】性)' },
        { term: '精巣腫瘍', desc: '【無痛性】陰囊内腫大' },
      ]}]
    },
    {
      label: '検査：尿細胞診',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '△' },
        { term: '膀胱癌', desc: '【有効】' },
        { term: '前立腺癌', desc: '【無効】' },
        { term: '精巣腫瘍', desc: '【無効】' },
      ]}]
    },
    {
      label: '検査：膀胱鏡',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '【無効】' },
        { term: '膀胱癌', desc: '【有効】' },
        { term: '前立腺癌', desc: '【無効】' },
        { term: '精巣腫瘍', desc: '【無効】' },
      ]}]
    },
    {
      label: '検査：生検',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '△(以前は禁忌)' },
        { term: '膀胱癌', desc: '【有効】' },
        { term: '前立腺癌', desc: '【有効】' },
        { term: '精巣腫瘍', desc: '【禁忌】' },
      ]}]
    },
    {
      label: '治療：手術',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '【転移】例でも行う' },
        { term: '膀胱癌', desc: '行う' },
        { term: '前立腺癌', desc: '行う' },
        { term: '精巣腫瘍', desc: '【転移】例でも行う' },
      ]}]
    },
    {
      label: '治療：ホルモン療法',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '行【わない】' },
        { term: '膀胱癌', desc: '行【わない】' },
        { term: '前立腺癌', desc: '行【う】' },
        { term: '精巣腫瘍', desc: '【手術】療法がこれに相当' },
      ]}]
    },
    {
      label: '治療：化学療法',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '行【わない】' },
        { term: '膀胱癌', desc: '行【う】' },
        { term: '前立腺癌', desc: '行わない〜△' },
        { term: '精巣腫瘍', desc: '行【う】' },
      ]}]
    },
    {
      label: '治療：放射線療法',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '行【わない】' },
        { term: '膀胱癌', desc: '行【う】' },
        { term: '前立腺癌', desc: '行【う】' },
        { term: '精巣腫瘍', desc: 'セミノーマ：行【う】／非セミノーマ：行【わない】' },
      ]}]
    },
    {
      label: '治療：その他',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '【サイトカイン】療法，【分子標的】薬，【免疫チェックポイント】阻害薬' },
        { term: '膀胱癌', desc: '上皮内癌に【BCG注入】療法' },
        { term: '前立腺癌', desc: '【TURP】は行わない' },
        { term: '精巣腫瘍', desc: '−' },
      ]}]
    },
  ]
},
{
  q: '②腎盂・尿管癌の組織型は【移行上皮】癌で，治療は【腎尿管全摘除】術である．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '③尿膜管癌は胎生期に臍から膀胱まで存在する尿膜管由来で，【膀胱頂】部に発生する【腺】癌である．治療は【尿膜管】を含めた切除である．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '④陰茎癌の組織は【扁平上皮】癌が多く，【鼠径】リンパ節転移が多い．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑤腎細胞癌と腎盂癌の比較',
  s: 'W05', ch: '泌尿器の癌の導入',
  type: 'grouped',
  categories: [
    {
      label: '組織',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '【淡明細胞】癌' },
        { term: '腎盂癌', desc: '【移行上皮】癌' },
      ]}]
    },
    {
      label: '尿路症状',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '出【にくい】' },
        { term: '腎盂癌', desc: '出【やすい】' },
      ]}]
    },
    {
      label: '造影CT',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '早期相で造影される' },
        { term: '腎盂癌', desc: '造影効果に【乏しい】' },
      ]}]
    },
    {
      label: '治療',
      groups: [{ label: '', rows: [
        { term: '腎細胞癌', desc: '腎臓部分切除術，【腎臓】全摘術' },
        { term: '腎盂癌', desc: '【腎尿管】全摘術' },
      ]}]
    },
  ]
},
{
  q: '⑥腎細胞癌の組織は【淡明細胞】癌，前立腺癌の組織は【腺】癌である．組織で移行上皮癌であるのは【膀胱】癌，【腎盂】癌・【尿管】癌である．精巣腫瘍の組織で最も多いのは【セミノーマ】である．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑦泌尿器系の癌のうち尿細胞診が有用なのは【腎盂】癌・【尿管】癌と【膀胱】癌で，このうち膀胱鏡が有用なのは【膀胱】癌のみである．【精巣】腫瘍では生検は禁忌．精巣腫瘍と腎細胞癌は転移例でも【手術】で治療する．【膀胱】癌は膀胱鏡で生検，【前立腺】癌は経【直腸】エコーで低エコー域を針生検する．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑧腎細胞癌の治療では化学放射線療法は【無】効で，IL-2やIFN-αなどの【サイトカイン】，【分子標的】薬，免疫チェックポイント阻害薬などを用いる．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑨膀胱癌の治療には手術，化学療法，放射線療法があり，他に【上皮内癌】に対して細胞性免疫を活性化する【BCG注入】療法がある．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑩前立腺癌の治療では【化学】療法は行わず，ホルモン療法や放射線【組織内照射】などを行う．手術の術式は【腹腔】内からの前立腺摘除が基本であり，経【尿道】的アプローチは行わない．',
  s: 'W05', ch: '泌尿器の癌の導入',
},
{
  q: '⑪精巣腫瘍の治療は手術がホルモン療法の役割も兼ねており，化学療法は奏効する．組織型のうち放射線治療が有効なのは【セミノーマ】である．',
  s: 'W05', ch: '泌尿器の癌の導入',
},

// W05 腎細胞癌
{
  q: '①腎細胞癌の組織型は【淡明細胞】癌が多く，【近】位尿細管由来のものが多い．リスクファクターは肥満，高血圧，【喫煙】，【VHL】遺伝子(半数に遺伝子異常あり)，【透析】などである．50～60歳代の【男】性に多い．転移は【血行】性転移が多く，【肺】＞【骨】(【溶骨】性)＞【肝】の順に転移しやすい．',
  s: 'W05', ch: '腎細胞癌',
},
{
  q: '②腎細胞癌の症状は肉眼的【血尿】，【腰背部痛】，【腹部腫瘤】(古典的三徴)，【発熱】，体重減少などである．また【エリスロポエチン】，【PTHrP】を産生することで【赤血球増加】症，高【Ca】血症をきたしたり，【腎静脈】内に腫瘍塞栓を生じたりする．',
  s: 'W05', ch: '腎細胞癌',
},
{
  q: '③腎細胞癌の画像検査としてエコー，CTを用いる．造影CTにて動脈相で【高】吸収，排泄相で【低】吸収を呈する腎腫瘤を認める．病理では，細胞質が【明るく】境界のはっきりした細胞が並ぶ【淡明細胞】癌が確認できる．',
  s: 'W05', ch: '腎細胞癌',
},
{
  q: '④腎細胞癌の治療は転移があったとしても，原則として【手術】(【腎摘除術】)を行い，転移巣の手術を行うこともある．【4】cm以下では部分切除術，【4】cm以上で腎全摘術を行う．【化学】療法と【放射線】療法に抵抗性の悪性腫瘍である．そのほかの治療に【サイトカイン】療法(【IFN-α】，【IL-2刺激】薬)や【分子標的薬】，【免疫チェックポイント】阻害薬がある．',
  s: 'W05', ch: '腎細胞癌',
},
{
  q: '⑤von Hippel-Lindau病は【常】染色体【顕】性遺伝疾患で，腎細胞癌の他に脳脊髄・【網膜】の【血管腫】，【褐色細胞】腫，【膵臓】腫瘍が多発・再発する．腎細胞癌の半数にVHL遺伝子の異常を認める．',
  s: 'W05', ch: '腎細胞癌',
},
{
  q: '⑥癌細胞が発現しているPD-L1は，PD-1と結合することでT細胞を抑制している．ニボルマブ(抗PD-1抗体薬，オプジーボ®)はPD-1と結合することにより，PD-1を癌細胞のPD-L1と結合させないことでT細胞の癌細胞に対する免疫反応を持続させる作用がある．適応に切除困難・転移性の【腎細胞癌】のほか，手術困難な【悪性黒色腫】，【非小細胞肺癌】，胃癌，Hodgkinリンパ腫，頭頸部癌などがある．副作用は【間質性肺炎】，1型【糖尿病】，下痢，掻痒感，甲状腺機能低下症など．',
  s: 'W05', ch: '腎細胞癌',
},

// W05 腎盂癌・尿管癌
{
  q: '①腎盂癌・尿管癌の組織型は膀胱癌と同様に【移行上皮】癌(【尿路上皮】癌)が多く，【膀胱】を含めて空間的・時間的に【多発】しやすい．症状は【血尿】，【水腎】症などの尿路症状が強く，【尿細胞診】陽性となりやすい．',
  s: 'W05', ch: '腎盂癌・尿管癌',
},
{
  q: '②腎盂癌・尿管癌では造影CTの造影効果に【乏し】い．治療は【腎尿管全摘除】術，化学療法，放射線療法などを行う．',
  s: 'W05', ch: '腎盂癌・尿管癌',
},

// W05 膀胱癌
{
  q: '①膀胱癌の組織型は【移行上皮】癌が多く，【腎盂】・【尿管】を含めて空間的・時間的に【多発】する．60～70代の男性に好発し，リスクファクターには【喫煙】，【芳香族アミン】(【ベンジジン】などの染料)がある．',
  s: 'W05', ch: '膀胱癌',
},
{
  q: '②膀胱癌の初発症状は【無症候性肉眼的血尿】が多いが，頻尿などの【膀胱刺激】症状を伴う場合もある．検査としてまず【尿細胞診】で腫瘍細胞を確認し，次にエコーや【MRI】(深達度評価に有用)での画像診断を行う．膀胱鏡で形態を確認し，【経尿道的膀胱腫瘍切除術】(【TURBT】)で採取した組織で生検し確定診断とする．',
  s: 'W05', ch: '膀胱癌',
},
{
  q: '③膀胱癌の膀胱鏡所見',
  s: 'W05', ch: '膀胱癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・粘膜の発赤，びらんを認める場合は【上皮内】癌を疑う' },
    { level: 0, text: '・乳頭状，有茎性の場合は【筋層非浸潤】癌を疑う' },
    { level: 0, text: '・結節性，広基性の場合は筋層浸潤癌を疑う' },
  ]
},
{
  q: '④膀胱癌の治療',
  s: 'W05', ch: '膀胱癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・【上皮内】癌：細胞性免疫を活性化する【BCG膀胱内】注入療法を第一選択' },
    { level: 0, text: '・筋層非浸潤癌：【TURBT】後に抗がん剤・【BCG膀胱内】注入療法を行うことがある' },
    { level: 0, text: '・筋層浸潤癌：根治的【膀胱全摘出】術，骨盤リンパ郭清，【尿路変向】術を行う' },
    { level: 0, text: '・進行癌：化学療法を行い，緩和目的で【放射線】療法を行うこともある' },
  ]
},
{
  q: '⑤経尿道的膀胱腫瘍切除術(TURBT)は経尿道的に切除鏡を膀胱内に挿入し，ループ型電極により腫瘍を内視鏡下に切除するものである．合併症として尿道【狭窄】，膀胱【穿孔】，急性【前立腺炎】や膀胱炎などがある．',
  s: 'W05', ch: '膀胱癌',
},
{
  q: '⑥尿路変向術の種類',
  s: 'W05', ch: '膀胱癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・尿管皮膚瘻：尿管を直接腹壁に固定する．手術操作が【簡単】．ストーマの【狭窄】，スキントラブルの可能性がある．【集尿袋】の貼付が必要．' },
    { level: 0, text: '・回腸導管：回腸を導管として用い，腹壁に固定する．ストーマの狭窄・陥没・突出，スキントラブルの可能性がある．【集尿袋】の貼付が必要．' },
    { level: 0, text: '・自排尿型代用膀胱：腸管を用いて新たな膀胱を作成，自己の尿道に再吻合する．従来通りの尿道を介した排尿が可能．術式が【複雑】．' },
  ]
},

// W05 尿膜管癌
{
  q: '①尿膜管癌は胎生期に臍から膀胱まで存在する胎生期遺残物である尿膜管に由来し，の好発部位は【膀胱頂】部である．ほとんどが【腺】癌で，非常に稀な悪性腫瘍である．症状は【無症候性血尿】で，尿細胞診や膀胱鏡，エコー，MRIなどで診断する．',
  s: 'W05', ch: '尿膜管癌',
},
{
  q: '②尿膜管癌の治療は【尿膜管】を含めた切除である．術後に局所再発し【やすく】，予後は膀胱癌より【不良】．',
  s: 'W05', ch: '尿膜管癌',
},

// W05 前立腺癌
{
  q: '①前立腺癌の組織型は【腺】癌であり，好発部位は【辺縁】領域(【外】腺)である．リスクファクターは加齢，【遺伝】，人種(日本人は【少な】い)，【食生活】の欧米化などが挙げられており，日本では近年死亡率が【増加】している．',
  s: 'W05', ch: '前立腺癌',
},
{
  q: '②前立腺癌の症状は初期は【無症状】であり，進行すると【排尿】障害が出てくる．また前立腺癌は【造骨】性【骨】転移をきたしやすく，骨痛を呈することがある．血液検査で【PSA】上昇がみられる(【4】ng/mL以上)．直腸指診で【石様硬】，表面【不整】な硬結・結節を触知する．有用な検査はエコー，MRI，骨シンチグラフィで，エコーでは【低】エコー域を，MRI T【2】WIで正常辺縁領域は【高】信号，癌は【低】信号を示す．',
  s: 'W05', ch: '前立腺癌',
},
{
  q: '③前立腺癌の確定診断に経直腸前立腺針生検を行い，【Gleason score】を用いる．Gleason scoreでは病理像で【面積】の大きな組織像を2カ所評価し，その合計点が6点以下は低リスク，【8】点以上は高リスクとなる．',
  s: 'W05', ch: '前立腺癌',
},
{
  q: '④前立腺癌の治療方針決定のためリスク分類に用いる因子として，【PSA】値，【Gleason score】，【TNM】分類がある．',
  s: 'W05', ch: '前立腺癌',
},
{
  q: '⑤前立腺癌の治療',
  s: 'W05', ch: '前立腺癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・低リスクの限局性癌であれば【PSA】監視療法を選択する場合もある' },
    { level: 0, text: '・前立腺に限局する場合は手術か放射線療法を行い，【ホルモン】療法を組み合わせることもある' },
    { level: 0, text: '・術後合併症：尿【失禁】，【勃起】障害，射精不能など' },
    { level: 0, text: '・前立腺外に浸潤する場合は【ホルモン】療法，【放射線】療法を行う' },
  ]
},
{
  q: '⑥前立腺癌に対する放射線療法',
  s: 'W05', ch: '前立腺癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・放射線療法には外照射と【組織内】照射(【小線源】療法)がある' },
    { level: 0, text: '・外照射の早期合併症：【下痢】，皮膚炎，悪心(放射線宿酔)など' },
    { level: 0, text: '・外照射の晩期合併症：【直腸】炎(症状は【血便】)，【膀胱】炎(症状は【血尿】)など' },
    { level: 0, text: '・外照射では照射野内の放射線強度に強弱をつける【強度変調放射線】治療が行われる' },
    { level: 0, text: '・【組織内】照射(【小線源】療法)は限局性癌にのみ適応があり，直腸など周辺臓器への線量を抑えられる' },
  ]
},

// W05 精巣腫瘍
{
  q: '①精巣腫瘍の約95％は【胚細胞】腫瘍で，【セミノーマ】(最多)と【非セミノーマ】に分けられる．好発年齢は乳幼児と20～40歳の2相性で，小児では【卵黄囊腫瘍】と【奇形腫】が多く，成人では【セミノーマ】，【胎児性癌】が多い．悪性リンパ腫は50歳以上に多い．リスクファクターに【停留精巣】がある．',
  s: 'W05', ch: '精巣腫瘍',
},
{
  q: '②精巣腫瘍の症状は陰囊の【無痛】性腫大で，透光性は【ない】．転移しやすい臓器・リンパ節は【後腹膜】リンパ節，【傍大動脈】リンパ節，【肺】である．',
  s: 'W05', ch: '精巣腫瘍',
},
{
  q: '③精巣腫瘍ではエコーで内部不均一な充実性腫瘤を認める．播種のおそれがあるため【生検】は禁忌．まず治療・診断を兼ねた【高位精巣摘除術】を行い，組織診断を行う．',
  s: 'W05', ch: '精巣腫瘍',
},
{
  q: '④セミノーマの病理像では，【two cell】pattern(大型円形で細胞質が【明るい】腫瘍細胞と小型のリンパ球浸潤)が特徴である．',
  s: 'W05', ch: '精巣腫瘍',
},
{
  q: '⑤セミノーマでは血中【LDH】が上昇する．非セミノーマでは血中【AFP】，【hCG】が上昇しやすい．',
  s: 'W05', ch: '精巣腫瘍',
},
{
  q: '⑥高位精巣摘除術後，セミノーマでは【化学】療法・【放射線】療法，非セミノーマでは【化学】療法と後腹膜リンパ節郭清を行う．2つの組織型のうち予後が良いのは【セミノーマ】である．5年生存率はⅠ期で90%以上，Ⅱ期で80%以上，Ⅲ期で20～30％．',
  s: 'W05', ch: '精巣腫瘍',
},

// W05 陰茎癌・尿道癌
{
  q: '①陰茎癌の組織型は【扁平上皮】癌が多く，上昇する腫瘍マーカーは【SCC】である．好発年齢は50～60歳代で，リスクファクターは【喫煙】，【HPV】感染，【真性包茎】，STDの既往，不衛生などである．肉眼所見は【無】痛性の【カリフラワー】様腫瘤，【潰瘍】，硬結を呈する．',
  s: 'W05', ch: '陰茎癌・尿道癌',
},
{
  q: '②陰茎癌は早期から【鼠径】リンパ節転移をきたしやすく，予後【不良】．治療は外科的治療(陰茎切断術・両側【鼠径】リンパ節郭清)と化学療法(【ブレオマイシン】)，放射線療法を行う．',
  s: 'W05', ch: '陰茎癌・尿道癌',
},
{
  q: '③尿道癌は尿道に発生する比較的まれな癌で，50歳以上の女性に多い．組織型としては【扁平上皮】癌が多く，病因として【HPV】が関与するとされる．排尿時の症状を伴いやすい．治療は外科的治療が主体．',
  s: 'W05', ch: '陰茎癌・尿道癌',
},
{
  q: '④尿道カルンクルは外尿道口付近に好発する米粒～豆粒大の良性腫瘍で，中年以降の【女】性に好発する．出血や排尿時痛をきたすことがあるが，無症状のことも多い．有症状の場合，治療として【電気凝固】・【切除】を行う．',
  s: 'W05', ch: '陰茎癌・尿道癌',
},

// W06 尿路結石
{
  q: '①尿路結石は上部尿路結石と下部尿路結石に分けられ，多いのは【上】部尿路結石で95％以上を占める．上部尿路結石は【腎】結石と【尿管】結石，下部尿路結石は【膀胱】結石と【尿道】結石をさす．',
  s: 'W06', ch: '尿路結石',
},
{
  q: '②尿管は【腎盂尿管】移行部，【総腸骨動脈】交叉部，【膀胱尿管】移行部の3つの生理的狭窄部位を有し，この部位で尿管結石を生じやすい．',
  s: 'W06', ch: '尿路結石',
},
{
  q: '③尿路結石は【男】性に多く，季節は【夏】に多い．症状は突然の激痛，【血尿】，嘔吐で，身体所見では【CVA叩打】痛がみられることが多い．尿管結石は片側性のものが多いが，両側性尿管結石を生じた場合は腎後性【無尿】に至ることがある．',
  s: 'W06', ch: '尿路結石',
},
{
  q: '④尿路結石の主な成分（最も多いのは【シュウ酸Ca】で約【80】%を占める）',
  s: 'W06', ch: '尿路結石',
  type: 'grouped',
  categories: [
    {
      label: 'シュウ酸Ca',
      groups: [{ label: '', rows: [
        { term: '形状', desc: '正【六面体】' },
        { term: 'X線透過性', desc: '【低い】(うつりやすい)' },
        { term: '生じやすい尿', desc: '【酸性】' },
      ]}]
    },
    {
      label: 'リン酸Ca',
      groups: [{ label: '', rows: [
        { term: '形状', desc: '【針状】，【板状】' },
        { term: 'X線透過性', desc: '【低い】(うつりやすい)' },
        { term: '生じやすい尿', desc: '【アルカリ性】' },
      ]}]
    },
    {
      label: '尿酸',
      groups: [{ label: '', rows: [
        { term: '形状', desc: '不規則板状' },
        { term: 'X線透過性', desc: '【高い】(うつりにくい)' },
        { term: '生じやすい尿', desc: '【酸性】' },
      ]}]
    },
    {
      label: 'シスチン',
      groups: [{ label: '', rows: [
        { term: '形状', desc: '【六角】形' },
        { term: 'X線透過性', desc: '【高い】(うつりにくい)' },
        { term: '生じやすい尿', desc: '【酸性】' },
      ]}]
    },
    {
      label: 'リン酸Mgアンモニウム',
      groups: [{ label: '', rows: [
        { term: '特徴', desc: '【慢性尿路感染症】が関与する．【珊瑚】状になりやすい' },
      ]}]
    },
  ]
},
{
  q: '⑤尿路結石の危険因子',
  s: 'W06', ch: '尿路結石',
  type: 'indent',
  rows: [
    { level: 0, text: '・尿路結石全般：【脱水】，尿流停滞(寝たきり，【神経因性膀胱】)' },
    { level: 0, text: '・Ca結石共通：血中Ca上昇(【副甲状腺機能亢進】症，【ビタミンD】製剤)，尿中Ca上昇(【ステロイド】，【Cushing】病，【RTA】Ⅰ型)' },
    { level: 0, text: '・シュウ酸Ca結石：【ビタミンC】過剰摂取，Ca摂取【不足】，男性' },
    { level: 0, text: '・リン酸Ca結石：尿中pH【上昇】' },
    { level: 0, text: '・尿酸結石：尿酸排泄促進薬(【ベンズブロマロン】)' },
    { level: 0, text: '・シスチン結石：遺伝' },
  ]
},
{
  q: '⑥尿路結石の治療薬',
  s: 'W06', ch: '尿路結石',
  type: 'indent',
  rows: [
    { level: 0, text: '・Ca結石：【サイアザイド】(尿中Ca低下)' },
    { level: 0, text: '・尿が酸性で生じやすい結石：【重炭酸ナトリウム】，【クエン酸】製剤(尿のアルカリ化)' },
    { level: 0, text: '・尿酸結石：【アロプリノール】，フェブキソスタットなど(ベンズブロマロンは×)' },
    { level: 0, text: '・シスチン結石：【D-ペニシラミン】，チオプロニン' },
  ]
},
{
  q: '⑦尿路結石でまず行う検査は【尿】検査で，【潜血】陽性となる．画像検査としては超音波検査，腎・尿管・膀胱単純撮影(KUB)，【単純CT】(推奨)を行う．',
  s: 'W06', ch: '尿路結石',
},
{
  q: '⑧尿管結石ではまず【NSAIDs坐薬】投与(疼痛が強く，嘔気を伴うため)を行う．輸液を行うこともある．1cm未満の石では飲水励行し【自然排石】を待つ．水腎症を伴い腎機能が低下している場合は【ESWL】(【体外衝撃波結石破砕】術)や【経尿道的尿管砕石】術を検討する．大きな【膀胱】結石に対しては，ESWLより経尿道的膀胱砕石術を行う．Ca摂取制限はシュウ酸Ca結石の【危険因子】であり，適度なCa摂取を勧める(Ca摂取量の推奨値は600～800mg/日)．',
  s: 'W06', ch: '尿路結石',
},
{
  q: '⑨体外より衝撃波をあて結石を破砕する治療を【ESWL】(【体外衝撃波結石破砕】術)という．【自然排石】が期待できない場合，【腎機能】低下を伴う場合に検討する．合併症に【血尿】，【皮下出血】，破砕結石尿管嵌頓，尿路感染症，腸管損傷などがある．禁忌は【妊婦】，【動脈瘤】を有する患者，出血傾向などである．',
  s: 'W06', ch: '尿路結石',
},
// W07
{
  q: '①泌尿器の感染症の比較',
  s: 'W07', ch: '泌尿器の感染症',
  type: 'grouped',
  categories: [
    {
      label: '腎盂腎炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【大腸菌】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【+】，発熱【+】，【腰】部(【CVA】叩打痛)' },
      ]}]
    },
    {
      label: '膀胱炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【大腸菌】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【+】，発熱【−】，【下腹】部' },
      ]}]
    },
    {
      label: '前立腺炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【大腸菌】，【淋菌】，【クラミジア】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【+】，発熱【+】，【会陰】部' },
      ]}]
    },
    {
      label: '精巣上体炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【大腸菌】，【淋菌】，【クラミジア】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【+】，発熱【+】，【陰囊】' },
      ]}]
    },
    {
      label: '精巣炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【ムンプスウイルス】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【−】，発熱【+】，【陰囊】' },
      ]}]
    },
    {
      label: '尿道炎',
      groups: [{ label: '', rows: [
        { term: '主な原因病原体', desc: '【淋菌】，【クラミジア】' },
        { term: '膿尿/発熱/痛い部位', desc: '膿尿【+】，発熱【−】，【尿道】' },
      ]}]
    },
  ]
},
// W07 膀胱炎・腎盂腎炎
{
  q: '①膀胱炎は尿道からの上行性感染で生じ，起因菌は【大腸菌】が多い．症状は下腹部不快感，【排尿時】痛，【頻尿】，【混濁】尿，血尿，残尿感などで，発熱はみられ【ない】．血液検査で特に異常を示さない．尿検査で白血球やグラム【陰】性【桿】菌を認めることが多い．治療は抗菌薬内服(【セフェム】系や【ニューキノロン】)．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '②出血性膀胱炎の原因は【アデノ】ウイルス，シクロフォスファミド，【放射線】などである．【膀胱鏡】検査にて点状出血や潰瘍形成を認める．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '③感染などの原因を伴わずに膀胱壁の線維化や萎縮をきたす原因不明の疾患を【間質性膀胱炎】という．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '④腎盂腎炎は上行性感染で膀胱炎に続発して起こることが多く，主な起因菌は【大腸】菌である．症状は【高熱】，悪寒戦慄，【悪心】・【嘔吐】，【腰痛】(【CVA叩打】痛陽性)など．菌血症や【敗血症】性ショック，DICをきたすこともある．尿検査で白血球や細菌を，血液検査で炎症反応上昇(白血球↑，CRP↑)を認める．治療は抗菌薬の点滴あるいは内服(【セフェム】系や【ニューキノロン】)を行う．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '⑤尿路結石に伴う【閉塞】性腎盂腎炎の診断にはエコーや【単純CT】を用い，治療は抗菌薬に加え【尿管ステント】を要する．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '⑥腎盂腎炎は院内感染では【尿路感染】症が最多で，リスクとなる不必要な【尿道カテーテル】は【抜去】する．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},
{
  q: '⑦尿路結核は結核の肺外病変の1つで，肺あるいは他臓器から【血】行性に腎皮質に感染し，腎から尿路へ下行する．腎結核では乾酪壊死巣を形成し，進行すると【漆喰】腎を認めることがある．尿管では【瘢痕】化や狭窄がみられる．膀胱結核では排尿痛，頻尿，残尿感などを呈し，【瘢痕】萎縮をきたす．尿検査で【無菌性膿】尿を認め，抗酸菌染色(Ziehl-Neelsen染色)で桿菌を認める．',
  s: 'W07', ch: '膀胱炎・腎盂腎炎',
},

// W07 前立腺炎
{
  q: '①急性前立腺炎の主な起因菌は【大腸菌】，【クラミジア】，淋菌である．症状として【発熱】，悪寒戦慄，【排尿時】痛，頻尿，【会陰部不快】感，ときに【尿閉】がみられる．直腸診で【圧痛】・【熱感】を伴う【腫大】した前立腺を触れる．血液検査では一過性の【PSA】上昇を認め，尿検査では【膿】尿，【細菌】尿を認める．菌血症を起こすおそれがあるため【前立腺マッサージ】は禁忌である．治療は抗菌薬(【セフェム】系や【ニューキノロン】)投与．',
  s: 'W07', ch: '前立腺炎',
},
{
  q: '②慢性前立腺炎は細菌性と非細菌性(慢性骨盤痛症候群)に分けられる．症状は【会陰部不快】感，【排尿時違和】感が主体で，発熱や膿尿を認め【ない】．慢性前立腺炎は前立腺【結石】の原因となる．治療は細菌性に対し抗菌薬，非細菌性に対しα1受容体遮断薬などを用いる．',
  s: 'W07', ch: '前立腺炎',
},

// W07 精巣上体炎・精巣炎
{
  q: '①精巣上体炎の起因菌には尿道炎をきたす【クラミジア】や【淋菌】，膀胱炎をきたす【大腸菌】がある．感染経路は精巣上体尾部からの【逆行】性感染が多い．また，【Behçet病】の一部として認めることもある．',
  s: 'W07', ch: '精巣上体炎・精巣炎',
},
{
  q: '②精巣上体炎の症状は【発熱】，【陰囊痛】などで，尿検査で【膿】尿，血液検査で【炎症反応】上昇を認める．精巣捻転症との鑑別が重要で，精巣上体炎では精巣を【挙上】すると陰囊痛が【軽減】するのが特徴である(【Prehn】徴候【陰】性)．精巣は【白膜】で覆われており，精巣上体炎から精巣炎へは波及し【にく】い．膿尿，血中CRP・WBC上昇がみられる．後遺症として精管通過障害を残すことがある．治療は抗菌薬投与．',
  s: 'W07', ch: '精巣上体炎・精巣炎',
},
{
  q: '③精巣炎は思春期以降の【流行性耳下腺】炎の合併症としてみられることが多い．症状は【発熱】，精巣の【疼痛】，腫脹，圧痛である．後遺症として，【造精機能】障害や精巣萎縮をきたすことがある．治療は【対症療法】で，安静，精巣の挙上固定，冷罨法などを行う．',
  s: 'W07', ch: '精巣上体炎・精巣炎',
},

// W07 尿道炎
{
  q: '①Neisseria gonorrhoeae(【淋菌】)はグラム【陰】性【球】菌で，診断に【PCR】法が有用(感度が【高】い)．潜伏期間は【2】～【7日】程度と短く，症状は【強】い排尿時痛，排尿時の【灼熱】感，【膿】性分泌物である．合併症に尿道【狭窄】がある．近年【ニューキノロン】耐性菌が増加しており，治療には【セフトリアキソン】(【第3世代セフェム】点滴)，アミノグリコシドを用いる．抗菌薬で根治しない場合，薬剤耐性菌か【クラミジア】混合感染(本症の20～30％で認める)を考える．',
  s: 'W07', ch: '尿道炎',
},
{
  q: '②Chlamydia trachomatis(【クラミジア】)はグラム染色で【染まらず】，診断には【PCR】法を用いる．潜伏期間は【1】～【3週間】程度と長く，主な症状は【軽度】の排尿時痛，【漿液】性分泌物である．合併症に【肝周囲】炎がある．治療にはテトラサイクリン，【マクロライド】，ニューキノロンを用いる(βラクタム系は【無】効)．',
  s: 'W07', ch: '尿道炎',
},
{
  q: '③淋菌・クラミジアに共通する尿道炎の合併症',
  s: 'W07', ch: '尿道炎',
  type: 'indent',
  rows: [
    { level: 0, text: '・男女共通：【咽頭】炎，【結膜】炎' },
    { level: 0, text: '・女性：【子宮頸管】炎，【骨盤内炎症性】疾患(【PID】)，【不妊】' },
    { level: 0, text: '・男性：【精巣上体】炎' },
  ]
},
{
  q: '④亀頭包皮炎は亀頭・包皮部の炎症で，主な原因菌は【黄色ブドウ球】菌，【カンジダ】などである．症状は亀頭と包皮の発赤，腫脹，疼痛，包皮からの排膿を呈する．治療は抗菌薬・副腎皮質ホルモン軟膏の塗布．',
  s: 'W07', ch: '尿道炎',
},
{
  q: '⑤性器ヘルペスは【単純ヘルペスウイルス】(HSV)1型や2型で起こる性感染症で，症状は性器の【水疱】，【潰瘍】，疼痛である．治療は抗ウイルス薬投与(アシクロビル，バラシクロビル)．',
  s: 'W07', ch: '尿道炎',
},
{
  q: '⑥尖圭コンジローマは【ヒトパピローマウイルス】(HPV)6型や11型によるウイルス感染症で，性器に【カリフラワー】状の無痛性の疣贅を生じる．治療はイミキモド軟膏塗布，凍結療法，電気焼灼，レーザー，外科的切除など．',
  s: 'W07', ch: '尿道炎',
},
{
  q: '⑦梅毒の原因菌は梅毒トレポネーマ(【Treponema pallidum】)．症状は口や性器の【無】痛性の硬結，硬性下疳，【扁平】コンジローマなどである．治療は【ペニシリン】(第一選択)，テトラサイクリンの投与．',
  s: 'W07', ch: '尿道炎',
},

// W08 陰囊腫大をきたす疾患
{
  q: '①無痛性陰囊腫大の原因疾患として【陰囊水腫】と【精巣腫瘍】などがある．両者を鑑別するには【ペンライト】を用い，透光性があるのが【陰囊水腫】である．',
  s: 'W08', ch: '陰囊腫大をきたす疾患',
},
{
  q: '②有痛性陰囊腫大の原因疾患として【精巣捻転症】，【精巣炎】・【精巣上体炎】，精巣損傷がある．腫大した精巣を持ち上げると疼痛が【増強】する身体所見を【Prehn】徴候といい，陽性例では【精巣捻転症】を考える．',
  s: 'W08', ch: '陰囊腫大をきたす疾患',
},
{
  q: '③陰囊水腫は【鞘状突起】が開存しているために，精巣の固有鞘膜腔に腹腔内の漿液が溜まることで生じる．【無】痛性陰囊腫大を呈し，ペンライトを当てると透光性が【ある】．自然軽快が望めるのは【2】歳頃までで，治療はこの年齢以降に【鞘状突起】結紮，精巣【固有鞘膜】切除などを行う．',
  s: 'W08', ch: '陰囊腫大をきたす疾患',
},
{
  q: '④精索静脈瘤のほとんどは【左】側に生じ，原因に【左腎】静脈の圧迫や【腎細胞癌】による塞栓などがある．特徴に，【立】位や【腹圧】上昇で陰囊腫大することがある．多くは無症状だが，陰囊が高温になることで【不妊】の原因になり，男性【不妊】の原因の30～40%を占める．治療は【精索静脈結紮】術である．',
  s: 'W08', ch: '陰囊腫大をきたす疾患',
},
{
  q: '⑤精巣捻転症は【思春】期に多く，精巣が【精索】を軸に回転することで生じる緊急疾患である．症状は【突然】の【陰囊】痛，【陰囊】腫大で【悪心嘔吐】を伴う．身体所見としてPrehn徴候【陽】性，精巣【挙上】，【精巣挙筋】反射【消失】がみられる．検査に【パワードプラ】超音波が有用で，血流【消失】を認める．治療は緊急【整復】・【固定】術を行い，発症【6】時間以内であれば造精機能温存が期待できる．同時に対側も精巣【固定】術を行う．',
  s: 'W08', ch: '陰囊腫大をきたす疾患',
},

// W08 男性不妊症
{
  q: '①男性不妊症の原因',
  s: 'W08', ch: '男性不妊症',
  type: 'grouped',
  categories: [
    {
      label: '造精機能障害（最多）',
      groups: [{ label: '', rows: [
        { term: '', desc: '【精索静脈瘤】' },
        { term: '', desc: '【停留】精巣' },
        { term: '', desc: '思春期以降の【ムンプス】精巣炎' },
        { term: '', desc: '【Kallmann症候群】：ゴナドトロピン投与で妊孕性が改善しうる' },
        { term: '', desc: '染色体異常(【Klinefelter症候群】)' },
      ]}]
    },
    {
      label: '精子の通過経路障害',
      groups: [{ label: '', rows: [
        { term: '', desc: '精巣上体炎' },
      ]}]
    },
    {
      label: '性機能障害',
      groups: [{ label: '', rows: [
        { term: '', desc: '勃起障害，射精障害' },
      ]}]
    },
    {
      label: 'その他',
      groups: [{ label: '', rows: [
        { term: '', desc: '前立腺炎，精囊炎' },
      ]}]
    },
  ]
},
{
  q: '②精液検査で精子を全く認めないものを【無精子】症，精子数が【1500】万/mL未満のものを乏精子症という．',
  s: 'W08', ch: '男性不妊症',
},

// W09 外傷
{
  q: '①腎損傷の症状に側腹部痛，血尿，ショックがある．腎損傷の患者をみたとき，まず【安静】にさせ【輸液】を行う．貧血が進行する場合は【輸血】を行う．改善せずバイタルサインが安定しない場合は【経カテーテル的腎動脈塞栓】術を行い，無効な場合は【開腹】止血を，それでも無効な場合は【腎摘出】術を行う．',
  s: 'W09', ch: '外傷',
},
{
  q: '②膀胱損傷の原因に外傷，医原性がある．膀胱造影にて造影剤の【漏出】を認める．治療は尿道カテーテル留置による保存療法，外科的治療．',
  s: 'W09', ch: '外傷',
},
{
  q: '③尿道損傷の診断に有用な検査は【逆行性尿道膀胱造影】である．損傷部位判明前の【尿道ブジー】や【膀胱鏡】検査は禁忌．治療は経皮的【膀胱瘻造設】を行い，その後，【尿路再建】術を行う．',
  s: 'W09', ch: '外傷',
},
{
  q: '④尿道損傷疑いの患者に尿道カテーテルを挿入する前に，【直腸指診】を行う．尿道損傷では前立腺高位浮動を認める．',
  s: 'W09', ch: '外傷',
},
{
  q: '⑤陰茎折症は【陰茎海綿体白膜】が断裂したものであり，受傷時には【断裂音】を伴い，【激痛】を生じる．血腫により断裂側と対側に屈曲する．治療は血腫除去と白膜断裂部の縫合．',
  s: 'W09', ch: '外傷',
},
{
  q: '⑥精巣損傷は外傷により精巣が挫傷・破裂するものである．【下腹】部に至る激痛を伴う．治療は安静【挙上】し【冷罨】法を行う．高度の血腫を伴う場合や白膜断裂時は手術を行い，やむを得ない場合は精巣摘出術も考慮する．',
  s: 'W09', ch: '外傷',
},
]